import { render, staticRenderFns } from "./toEvaluate.vue?vue&type=template&id=670e0e82&scoped=true&"
import script from "./toEvaluate.vue?vue&type=script&lang=js&"
export * from "./toEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./toEvaluate.vue?vue&type=style&index=0&id=670e0e82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670e0e82",
  null
  
)

export default component.exports